import { User } from './user.model';

export class UserConfiguration {
  signMail: string;

  constructor(userConfigPartial: Partial<UserConfiguration>) {
    Object.assign(this, userConfigPartial);
  }
}
